import React from "react";
import Arrow from "../../assets/Icons/Arrow";
import Arrow2 from "../../assets/Icons/Arrow2";
import { Link } from "react-router-dom";

function MiddleCard() {
  return (
    <div className=" bg-white dark:bg-black mb-[4rem]">
      <div className="sm:mt-5  ml-3 mt-3 relative flex  w-full justify-center  bg-white dark:bg-black ">
        {/* <h3 className="text-black font-sans font-bold text-[20px] ml-5 mt-2 ">
                About us
          </h3> */}
        <div className="sm:flex sm:flex-row  sm:gap-5  bg-white  dark:bg-black aboutUsShadow rounded-[20px] w-[90%] sm:h-[426px]  mr-5 h-[550px] mb-10 relative">
          <div className="sm:max-w-[325px]">
            <img
              src={require("../../assets/img/card.jpg")}
              alt=""
              className=" h-[101%] w-[325px] mt-[-3px] bg-gray-400 mr-10  rounded-tl-[20px] sm:rounded-bl-[20px]  hidden md:block"
            />
            <img
              src={require("../../assets/img/imghomesmall.jpg")}
              alt=""
              className="h-[216px] w-[full] bg-gray-400 mr-10 rounded-t-lg sm:rounded-l-lg  sm:hidden"
            />
          </div>
          <div className=" mt-4 max-sm:px-4 dark:text-white ">
            <h2 className="font-sans text-[#053676] dark:text-[#2A71E8] pb-3 sm:pb-5 font-[700]  sm:text-[36px] ">
              {" "}
              DMB Translation Services
            </h2>
            <p className="text-black font-[600] sm:w-[35rem] sm:text-[17px] text-[15.5px] font-sans dark:text-white  ">
              Is a Social-Enterprise seeking to inspire inclusive communities
              for people living with disabilities through the development and
              provision of modern, affordable, and reliable assistive
              technologies. Our Flagship product, the Digital Sign Language
              Interpreter, is a mobile and web Application that translates Sign
              language to Speech and Text, and vice versa, all in real-time.
            </p>
          </div>
          <div className="absolute bottom-2 right-2 sm:bottom-3 sm:right-3 rounded-[25px] bg-[#2a71e8] w-32 items-center justify-center flex space-x-2 p-1 px-2">
            <p className="text-white">Continue... </p>

            <Link to="/input">
              <div className="max-sm:hidden">
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.11 0C23.4571 0 30.22 6.76294 30.22 15.11C30.22 23.4571 23.4571 30.22 15.11 30.22C6.76294 30.22 0 23.4571 0 15.11C0 6.76294 6.76294 0 15.11 0ZM13.3492 8.74918L17.9492 13.1603H6.82387C6.01354 13.1603 5.36161 13.8122 5.36161 14.6226V15.5974C5.36161 16.4078 6.01354 17.0597 6.82387 17.0597H17.9492L13.3492 21.4708C12.7582 22.0374 12.746 22.9818 13.3248 23.5606L13.995 24.2247C14.5677 24.7975 15.4938 24.7975 16.0605 24.2247L24.1455 16.1458C24.7183 15.573 24.7183 14.647 24.1455 14.0803L16.0605 5.98917C15.4878 5.41645 14.5617 5.41645 13.995 5.98917L13.3248 6.65327C12.746 7.23818 12.7582 8.18255 13.3492 8.74918Z"
                    fill="white"
                  />
                </svg>

                {/* <Arrow /> */}
              </div>
              <div className="sm:hidden">
                <Arrow2 />
              </div>
            </Link>
          </div>
        </div>
        {/* <div className=" hidden md:block bg-white shadow-lg rounded-[20px] ml-10 sm:h-[426px] w-[400px]  mr-10">
          <div className="border border-[#053676] w-[349px]  rounded-[20px]  h-[160px] ml-5 mt-10 ">
            <img
              src={require("../../assets/img/menue.png")}
              className="ml-[130px] mt-2"
              alt=""
            />
            <h3 className="ml-[100px] text-[#09062C] font-sans font-bold">
              TEXT AND SPEECH
            </h3>
            <h3 className="ml-[150px] text-[#09062C] font-sans font-bold">
              {" "}
              To
            </h3>
            <h3 className="ml-[100px] text-[#BE2117]"> SIGN LANGUAGE</h3>
          </div>

          <div className="border border-[#053676] w-[349px]  rounded-[20px]  h-[160px] ml-5 mt-10">
            <img
              src={require("../../assets/img/clamphand.png")}
              className="ml-[130px] mt-2"
              alt=""
            />
            <h3 className="ml-[100px] text-[#09062C] font-sans font-bold">
              TEXT AND SPEECH
            </h3>
            <h3 className="ml-[150px] text-[#09062C] font-sans font-bold">
              {" "}
              To
            </h3>
            <h3 className="ml-[100px] text-[#BE2117]"> SIGN LANGUAGE</h3>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default MiddleCard;
